<app-debounce-search
  [searchTerm]="searchTerm"
  (searchUpdate)="updateSearchTerm($event)"
></app-debounce-search>

<ul *ngIf="searchTerm && !hasBeenSelected">
  <div class="item-container">
    <li
      *ngFor="let item of items | filterTerm: searchTerm"
      (click)="selectSearchTerm(item)"
    >
      {{ item }}
    </li>
  </div>
</ul>
